const getMilkywireLogo = () => {
  return 'https://images.milkywire.com/public/milkywire-logo-scribbled.png';
};

export default getMilkywireLogo;
